module.exports = __webpack_public_path__ + "img/4.ea4bc852.png";